import MVPQuestions from './MVPQuestions';
export default MVPQuestions;
